import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "" }, "id", -1)
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "text-center min-w-150px" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "w-100 overflow-hidden" }

import { ref, onMounted, provide } from "vue";
import { ApplicationStatusType } from "@/core/types/ApplicationInfos";
import UserService from "../services/UserService";
import { ApplicationType } from "@/core/types/ApplicationInfos";
import SimpleForm from "@/components/SimpleForm.vue";
import OpenAccountForm from "@/projects/tenant/modules/accounts/components/form/OpenAccountForm.vue";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import OpenTradeAccount from "./modal/OpenTradeAccount.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserApplications',
  props: {
    partyId: {}
  },
  emits: ["application-approved"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const isLoading = ref(true);
const pendingApplications = ref(Array<any>());
const criteria = ref({
  page: 1,
  size: 10,
  partyId: props.partyId,
  type: ApplicationType.TradeAccount,
  // status: ApplicationStatusType.AwaitingApproval,
  sortField: "Status",
  sortFlag: false,
});
const openTradeAccountRef = ref(null);
const selectedApplication = ref<any>();

provide(AccountInjectionKeys.APPLICATION_DETAILS, selectedApplication);

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  isLoading.value = true;
  try {
    const res = await UserService.queryApplications(criteria.value);
    pendingApplications.value = res.data;
    criteria.value = res.criteria;
    isLoading.value = false;
  } catch (error) {
    console.log(error);
  }
};

const modelRef = ref<InstanceType<typeof SimpleForm>>();
const openAccounts = () => {
  openTradeAccountRef.value?.show(props.partyId);
};
const openApplicationDetailForm = (_item: any) => {
  selectedApplication.value = _item;
  modelRef.value?.show();
};

const onApplicationApproved = async () => {
  modelRef.value?.hide();
  emits("application-approved");
};

onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("title.tradeAccount")), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openAccounts())),
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.createTradeAccount")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.fullName")), 1),
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.type")), 1),
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.currency")), 1),
                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("fields.leverage")), 1),
                _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.accountRole")), 1),
                _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.referralCode")), 1),
                _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.status")), 1),
                _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("action.action")), 1)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                  _createVNode(_component_LoadingRing)
                ]))
              : (!isLoading.value && pendingApplications.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingApplications.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(item.id), 1),
                        _createElementVNode("td", null, _toDisplayString(item.user?.firstName + " " + item.user?.lastName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.supplement?.accountType
                    ? _ctx.$t(`type.account.${item.supplement?.accountType}`)
                    : "***"), 1),
                        _createElementVNode("td", null, _toDisplayString(item.supplement?.currencyId
                    ? _ctx.$t(`type.currency.${item.supplement?.currencyId}`)
                    : "***"), 1),
                        _createElementVNode("td", null, _toDisplayString(item.supplement?.leverage
                    ? item.supplement?.leverage + ":1"
                    : "***"), 1),
                        _createElementVNode("td", null, _toDisplayString(item.supplement?.role
                    ? _ctx.$t(`type.accountRole.${item.supplement?.role}`)
                    : "***"), 1),
                        _createElementVNode("td", null, _toDisplayString(item.supplement?.referCode === ""
                    ? "***"
                    : item.supplement?.referCode), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", {
                    'badge-primary':
                      item.status === _unref(ApplicationStatusType).Approved,
                    'badge-warning':
                      item.status === _unref(ApplicationStatusType).AwaitingApproval,
                    'badge-danger':
                      item.status === _unref(ApplicationStatusType).Rejected,
                    'badge-success':
                      item.status === _unref(ApplicationStatusType).Completed,
                  }])
                          }, _toDisplayString(_ctx.$t(`type.applicationStatus.${item.status}`)), 3)
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_TimeShow, {
                            "date-iso-string": item.createdOn
                          }, null, 8, ["date-iso-string"])
                        ]),
                        _createElementVNode("td", _hoisted_21, [
                          _createVNode(_component_el_button, {
                            onClick: ($event: any) => (openApplicationDetailForm(item))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.details")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]))
          ]),
          _createVNode(_component_TableFooter, {
            onPageChange: fetchData,
            criteria: criteria.value
          }, null, 8, ["criteria"])
        ])
      ]),
      _createVNode(SimpleForm, {
        ref_key: "modelRef",
        ref: modelRef,
        "disable-footer": "",
        "is-loading": isLoading.value,
        title: _ctx.$t('title.pendingApplications'),
        width: 900,
        style: {"overflow":"hidden"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(OpenAccountForm, {
              onApplicationSubmitted: onApplicationApproved,
              siteId: selectedApplication.value.siteId
            }, null, 8, ["siteId"])
          ])
        ]),
        _: 1
      }, 8, ["is-loading", "title"])
    ]),
    _createVNode(OpenTradeAccount, {
      ref_key: "openTradeAccountRef",
      ref: openTradeAccountRef,
      onApplicationSubmitted: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1)))
    }, null, 512)
  ], 64))
}
}

})